import axios from "axios";
import API_BASE_URL from "../../../../config/apiConfig";

export const getNoRecentVisitByCip = async (cipId) => {
  try {
    const token = localStorage.getItem("token");

    const url = `${API_BASE_URL}/api/PatientInfo/No-Recent-Visit`;

    const response = await axios.get(url, {
      params: {
        page: 1,
        pageSize: 1, // ya que buscas por cipId, con 1 basta
        cipId: cipId?.trim(),
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // La API devuelve { data: [...], page, pageSize, total, totalPages }
    return response.data?.data ?? [];
  } catch (error) {
    console.error(`Error fetching No Recent Visit for CIP ${cipId}:`, error);
    throw error;
  }
};
